var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm.partner.type === "natural"
          ? [
              _c("div", { staticClass: "col-md-4 offset-md-right-9" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.partner.gender,
                          expression: "partner.gender",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.hasError("gender") },
                      on: {
                        mouseover: function ($event) {
                          return _vm.showInfo("gender")
                        },
                        mouseleave: _vm.hideInfo,
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.partner,
                            "gender",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.genders, function (gender) {
                      return _c("option", { domProps: { value: gender } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.__(`forms.options.genders.${gender}`)) +
                            "\n            "
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    on: {
                      mouseover: function ($event) {
                        return _vm.showInfo("pre_title")
                      },
                      mouseleave: _vm.hideInfo,
                    },
                  },
                  [
                    _c("multiselect", {
                      attrs: {
                        options: _vm.localPreTitles,
                        multiple: true,
                        "track-by": "input",
                        label: "input",
                        "internal-search": false,
                        placeholder: _vm.__("forms.placeholders.pre_title"),
                      },
                      on: { "search-change": _vm.searchPreTitleInput },
                      model: {
                        value: _vm.partner.tempPreTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.partner, "tempPreTitle", $$v)
                        },
                        expression: "partner.tempPreTitle",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      class: { "error-area": _vm.hasError("title_prefix") },
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: _vm.getError("title_prefix"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showInfo("title_prefix")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.partner.first_name,
                        expression: "partner.first_name",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.hasError("first_name") },
                    attrs: {
                      type: "text",
                      placeholder: _vm.__("forms.placeholders.first_name"),
                    },
                    domProps: { value: _vm.partner.first_name },
                    on: {
                      click: function ($event) {
                        return _vm.showInfo("first_name")
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.partner, "first_name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasError("first_name")
                    ? _c("span", {
                        staticClass: "error-area",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "bottom",
                          title: _vm.getError("first_name"),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.partner.last_name,
                        expression: "partner.last_name",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.hasError("last_name") },
                    attrs: {
                      type: "text",
                      placeholder: _vm.__("forms.placeholders.last_name"),
                    },
                    domProps: { value: _vm.partner.last_name },
                    on: {
                      click: function ($event) {
                        return _vm.showInfo("last_name")
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.partner, "last_name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasError("last_name")
                    ? _c("span", {
                        staticClass: "error-area",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "bottom",
                          title: _vm.getError("last_name"),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    on: {
                      mouseover: function ($event) {
                        return _vm.showInfo("post_title")
                      },
                      mouseleave: _vm.hideInfo,
                    },
                  },
                  [
                    _c("multiselect", {
                      attrs: {
                        options: _vm.localPostTitles,
                        multiple: true,
                        "track-by": "input",
                        label: "input",
                        "internal-search": false,
                        placeholder: _vm.__("forms.placeholders.post_title"),
                      },
                      on: {
                        "search-change": _vm.searchPostTitleInput,
                        click: function ($event) {
                          return _vm.showInfo("title_postfix")
                        },
                      },
                      model: {
                        value: _vm.partner.tempPostTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.partner, "tempPostTitle", $$v)
                        },
                        expression: "partner.tempPostTitle",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      class: { "error-area": _vm.hasError("title_prefix") },
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: _vm.getError("title_postfix"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showInfo("title_postfix")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "position-relative" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.partner.birthdate,
                          expression: "partner.birthdate",
                        },
                      ],
                      staticClass: "form-control has-icon",
                      class: { "is-invalid": _vm.hasError("birthdate") },
                      attrs: {
                        type: "text",
                        placeholder: _vm.__("forms.placeholders.birthdate"),
                      },
                      domProps: { value: _vm.partner.birthdate },
                      on: {
                        click: function ($event) {
                          return _vm.showInfo("date_dmy")
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.partner,
                            "birthdate",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "icon icon-calendar" }),
                    _vm._v(" "),
                    _c("span", {
                      class: { "error-area": _vm.hasError("birthdate") },
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: _vm.getError("birthdate"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showInfo("date_dmy")
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-9" }, [
                _c("div", { staticClass: "form-group select-wrapper" }, [
                  _c("label", [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.__(
                            "forms.placeholders.by_partner_type.natural.citizenship"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.partner.country,
                            expression: "partner.country",
                          },
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.hasError("country") },
                        on: {
                          mouseover: function ($event) {
                            return _vm.showInfo("country")
                          },
                          mouseleave: _vm.hideInfo,
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.partner,
                              "country",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.countries, function (country, code) {
                        return _c("option", { domProps: { value: code } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(country) +
                              "\n              "
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]
          : [
              _c("div", { staticClass: "col-md-9" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.partner.first_name,
                        expression: "partner.first_name",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.hasError("first_name") },
                    attrs: {
                      type: "text",
                      placeholder: _vm.__("forms.placeholders.name"),
                    },
                    domProps: { value: _vm.partner.first_name },
                    on: {
                      click: function ($event) {
                        return _vm.showInfo("name")
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.partner, "first_name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasError("first_name")
                    ? _c("span", {
                        staticClass: "error-area",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "bottom",
                          title: _vm.getError("first_name"),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.partner.reg_number,
                        expression: "partner.reg_number",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.hasError("reg_number") },
                    attrs: {
                      type: "text",
                      placeholder: _vm.__("forms.placeholders.reg_number"),
                    },
                    domProps: { value: _vm.partner.reg_number },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.partner, "reg_number", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasError("reg_number")
                    ? _c("span", {
                        staticClass: "error-area",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "bottom",
                          title: _vm.getError("reg_number"),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ],
        _vm._v(" "),
        _c("div", { staticClass: "col-md-9" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.partner.street,
                  expression: "partner.street",
                },
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.hasError("street") },
              attrs: {
                type: "text",
                placeholder: _vm.__("forms.placeholders.street"),
              },
              domProps: { value: _vm.partner.street },
              on: {
                click: function ($event) {
                  return _vm.showInfo("street")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.partner, "street", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.hasError("street")
              ? _c("span", {
                  staticClass: "error-area",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.getError("street"),
                  },
                })
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.partner.street_nr,
                  expression: "partner.street_nr",
                },
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.hasError("street_nr") },
              attrs: {
                type: "text",
                placeholder: _vm.__("forms.placeholders.street_nr"),
              },
              domProps: { value: _vm.partner.street_nr },
              on: {
                click: function ($event) {
                  return _vm.showInfo("street_nr")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.partner, "street_nr", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.hasError("street_nr")
              ? _c("span", {
                  staticClass: "error-area",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.getError("street_nr"),
                  },
                })
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.partner.zip_code,
                  expression: "partner.zip_code",
                },
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.hasError("zip_code") },
              attrs: {
                type: "text",
                placeholder: _vm.__("forms.placeholders.zip_code"),
              },
              domProps: { value: _vm.partner.zip_code },
              on: {
                click: function ($event) {
                  return _vm.showInfo("zip_code")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.partner, "zip_code", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.hasError("zip_code")
              ? _c("span", {
                  staticClass: "error-area",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.getError("zip_code"),
                  },
                })
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-9" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.partner.city,
                  expression: "partner.city",
                },
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.hasError("city") },
              attrs: {
                type: "text",
                placeholder: _vm.__("forms.placeholders.city"),
              },
              domProps: { value: _vm.partner.city },
              on: {
                click: function ($event) {
                  return _vm.showInfo("city")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.partner, "city", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.hasError("city")
              ? _c("span", {
                  staticClass: "error-area",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.getError("city"),
                  },
                })
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.partner.type === "natural"
          ? [
              _c("div", { staticClass: "col-md-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.partner.phone,
                        expression: "partner.phone",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.hasError("phone") },
                    attrs: {
                      type: "text",
                      placeholder: _vm.__("forms.placeholders.phone"),
                    },
                    domProps: { value: _vm.partner.phone },
                    on: {
                      mouseover: function ($event) {
                        return _vm.showInfo("phone")
                      },
                      mouseleave: _vm.hideInfo,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.partner, "phone", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasError("phone")
                    ? _c("span", {
                        staticClass: "error-area",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "bottom",
                          title: _vm.getError("city"),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-9" }, [
                _c("div", { staticClass: "form-group select-wrapper" }, [
                  _c("label", [
                    _c("span", { staticClass: "text width-200px" }, [
                      _vm._v(
                        _vm._s(
                          _vm.__("forms.placeholders.preferred_language")
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.partner.language,
                            expression: "partner.language",
                          },
                        ],
                        staticClass: "form-control partner-language",
                        class: { "is-invalid": _vm.hasError("language") },
                        on: {
                          mouseover: function ($event) {
                            return _vm.showInfo("language")
                          },
                          mouseleave: _vm.hideInfo,
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.partner,
                              "language",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _vm._l(
                          _vm.shareholderLanguages.austrian,
                          function (language) {
                            return _c(
                              "option",
                              { domProps: { value: language } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.__(
                                        `project.shareholder_languages.version_1.${language}`
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "disabled" } },
                          [_vm._v("- - - - - - - - - - - - -")]
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.shareholderLanguages.other,
                          function (language) {
                            return _c(
                              "option",
                              { domProps: { value: language } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.__(
                                        `project.shareholder_languages.version_1.${language}`
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          : [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-group select-wrapper" }, [
                  _c("label", [
                    _c("span", { staticClass: "text width-140px" }, [
                      _vm._v(
                        _vm._s(
                          _vm.__(
                            "forms.placeholders.by_partner_type.legal.citizenship"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.partner.country,
                            expression: "partner.country",
                          },
                        ],
                        staticClass: "form-control partner-country",
                        class: { "is-invalid": _vm.hasError("country") },
                        on: {
                          mouseover: function ($event) {
                            return _vm.showInfo("country")
                          },
                          mouseleave: _vm.hideInfo,
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.partner,
                              "country",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.countries, function (country, code) {
                        return _c("option", { domProps: { value: code } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(country) +
                              "\n              "
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _vm.partner.representative
      ? _c(
          "div",
          { staticClass: "representative mt-3" },
          [
            _c("partner-fields", {
              attrs: {
                partner: _vm.partner.representative,
                "parent-type": _vm.partner.type,
                depth: _vm.depth + 1,
                "filled-from-draft": _vm.filledFromDraft,
                "validation-errors": _vm.hasError("representative")
                  ? _vm.getError("representative")
                  : {},
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }